import { useQuery } from '@tanstack/react-query';

import { QueryKey } from '@/config/query-client';
import { fetchCrunchbaseSearchResults } from '@/api/v4/crunchbase.api';
import { PRODUCT } from '@/user/products/product.type';
import { useUserProducts } from '@/user/products/use-user-products';

export const useCrunchbaseOrganizationsSearch = (searchPhrase: string) => {
  const { hasRequiredProduct } = useUserProducts();
  const isCrunchbaseEnabled = hasRequiredProduct(PRODUCT.CRUNCHBASE);

  return useQuery({
    queryKey: [QueryKey.CompaniesSearchCrunchbase, searchPhrase],
    queryFn: () => {
      if (searchPhrase.trim() === '') return [];
      return fetchCrunchbaseSearchResults(searchPhrase);
    },
    enabled: isCrunchbaseEnabled && searchPhrase.trim() !== '',
  });
};
